import React from 'react';
import classnames from 'classnames';
import CSSclasses from './error-message.scss';
export class ErrorMessage extends React.Component {
  render() {
    const {
      error,
      className
    } = this.props;
    if (!error || error && error.isSuccessed) {
      return null;
    }
    return /*#__PURE__*/React.createElement("span", {
      className: classnames(CSSclasses.wrapper, className)
    }, /*#__PURE__*/React.createElement("span", {
      className: CSSclasses[error.colors.message]
    }, error.message));
  }
}